import { NetworkStatus } from '@cbridge-utils/network';
import { IOrderLifetimeRuleStore } from './orderLifetimeRule.interface';

export const orderLifetimeRuleInitialState: IOrderLifetimeRuleStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
